import { StockDocumentInterface } from '../../../../../common/types/interfaces'
import { Item } from '../item/Item'
import classes from './List.module.sass'

type Props = {
  startEdit: (el: StockDocumentInterface) => void
  showDetails: (el: StockDocumentInterface) => void
  list: StockDocumentInterface[] | []
  loading: boolean
}

export const List = ({ startEdit, list, showDetails, loading }: Props) => {
  return (
    <div className={classes.container}>
      {!list?.length && !loading ? (
        <div className={classes.Message}>Нет документов</div>
      ) : (
        list.map((el) => (
          <Item showDetails={showDetails} el={el} startEdit={startEdit} key={el.id} />
        ))
      )}
    </div>
  )
}
